export default interface ILocation {
	organisationId: number;
	branchId: number;
}

export const InitialLocationState: ILocation = {
	organisationId: 1,
	branchId: 1,
};
